import htmlEncode from 'js-htmlencode'
import { envelope } from './index'

export default function FindItem(id) {
  return envelope`
    <m:FindItem Traversal="Shallow">
      <m:ItemShape>
        <t:BaseShape>IdOnly</t:BaseShape>
      </m:ItemShape>
      <m:Restriction>
        <t:Contains ContainmentMode="Substring" ContainmentComparison="IgnoreCase">
          <t:FieldURI FieldURI="message:InternetMessageId"/>
          <t:Constant Value="${htmlEncode(id)}"/>
        </t:Contains>
      </m:Restriction>
      <m:ParentFolderIds>
        <t:DistinguishedFolderId Id="inbox" />
        <t:DistinguishedFolderId Id="outbox" />
        <t:DistinguishedFolderId Id="sentitems" />
        <t:DistinguishedFolderId Id="msgfolderroot" />
      </m:ParentFolderIds>
    </m:FindItem>
  `
}
